var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProtection(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.4668 28.6521C5.4668 16.6391 15.7479 7.06885 28.2168 7.06885C40.6857 7.06885 50.9668 16.6391 50.9668 28.6521C50.9668 29.6186 50.1833 30.4021 49.2168 30.4021H7.2168C6.2503 30.4021 5.4668 29.6186 5.4668 28.6521ZM9.05633 26.9021H47.3773C46.4428 17.8106 38.3043 10.5688 28.2168 10.5688C18.1293 10.5688 9.99084 17.8106 9.05633 26.9021Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2168 26.9119C29.1833 26.9119 29.9668 27.6954 29.9668 28.6619V45.6219C29.9668 50.1214 26.2646 53.7355 21.8001 53.7355C17.3357 53.7355 13.6335 50.1214 13.6335 45.6219C13.6335 44.6554 14.417 43.8719 15.3835 43.8719C16.35 43.8719 17.1335 44.6554 17.1335 45.6219C17.1335 48.1514 19.2315 50.2355 21.8001 50.2355C24.3688 50.2355 26.4668 48.1514 26.4668 45.6219V28.6619C26.4668 27.6954 27.2503 26.9119 28.2168 26.9119Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2168 3.56885C29.1833 3.56885 29.9668 4.35235 29.9668 5.31885V8.81885C29.9668 9.78535 29.1833 10.5688 28.2168 10.5688C27.2503 10.5688 26.4668 9.78535 26.4668 8.81885V5.31885C26.4668 4.35235 27.2503 3.56885 28.2168 3.56885Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtection);
export default __webpack_public_path__ + "static/media/protection.785b746c.svg";
export { ForwardRef as ReactComponent };